import React from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";

//processDescription should be something that makes sense after the phrase "An error occurred"
//errorMsg is optional and should give extra detail, if necessary.
function ErrorComponent(props) {
	let processDescription = props.processDescription;
	let errorMsg = props.errorMsg;
	let message = errorMsg ? errorMsg : this.loginReponseData;
	return (
		<div className="errorReport">
			<h2 className="errorReportHeader">{"An erorr occurred "+processDescription}</h2>
			<p className="errorMessage">{message}</p>
			<p>{"You can try again by reloading this page. If the problem perists, "}<Link to="/contact">please contact us</Link>.</p>
		</div>
	);
}

ErrorComponent.propTypes = {
	processDescription: PropTypes.string,
	errorMsg: PropTypes.string
};

export default ErrorComponent;


// WEBPACK FOOTER //
// ./src/components/ErrorComponent.js